import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import {IconFont} from "@/lib/util";
import AudioItem from "@/views/editor/service/atmosphere/atmosphere/AudioItem.vue";
import {useRoute} from "vue-router";
import {AEditor} from "@/views/editor/service/editor";
import {computed, reactive} from "vue";
import Atmosphere from "@/views/editor/service/atmosphere/atmosphere/index";
import {UploadFile} from "ant-design-vue";
import {session} from "@/model/session";
import SingleUploadView from "@/views/share/SingleUploadView.vue";
import dayjs, {Dayjs} from "dayjs";
import DynamicInput from "@/views/editor/components/system/DynamicInput.vue";
import {Material} from "@/model/material";


export default /*@__PURE__*/_defineComponent({
  __name: 'CAtmosphereBase',
  setup(__props) {


const router = useRoute()
const editor = router.meta.editor as AEditor;
const atmosphere = computed(() => editor.biz.active.atmosphere as Atmosphere)
const theme = editor.meta.theme[editor.active.preview.status]
const material = router.meta.material as Material;
const info = reactive({music: {show: false}, date_range: [dayjs(editor.meta.begin_at), dayjs(editor.meta.end_at)]})

const disabledDate = (date: Dayjs) => {
  if (info.date_range.length == 0) return false
  let tooEarly = date.valueOf() < new Date().valueOf()
  const tooLate = info.date_range[1].diff(date, 'days') > 30 || date.valueOf() < new Date().valueOf()
  return tooEarly || tooLate
}

const onRangePickerChange = (v: Dayjs[]) => {
  if (v.length != 2) return
  editor.meta.begin_at = v[0].toISOString()
  editor.meta.end_at = v[1].toISOString()
}

/***
 ==========    音乐      =============
 */

const onUploadChange = (j: Record<string, UploadFile>) => {
  if (j.file.status == 'done') {
    atmosphere.value.opt.music_url = j.file.url ?? ''
  }
}

const setNoMusic = () => {
  atmosphere.value.opt.music_url = ''
  atmosphere.value.active.audio.url = ''
  atmosphere.value.audio.pause()
  atmosphere.value.audio.src = ''
  atmosphere.value.active.audio.playing = false
}

const setMusic = (url: string) => {
  if (atmosphere.value.opt.music_url == url && atmosphere.value.active.audio.playing) atmosphere.value.audio.pause()
  else {
    atmosphere.value.opt.music_url = url
    atmosphere.value.active.audio.url = url
    atmosphere.value.audio.src = url
    atmosphere.value.audio.play()
    atmosphere.value.audio.loop = true
  }
}


return (_ctx: any,_cache: any) => {
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_range_picker = _resolveComponent("a-range-picker")!
  const _component_a_flex = _resolveComponent("a-flex")!
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_upload = _resolveComponent("a-upload")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_list = _resolveComponent("a-list")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_drawer = _resolveComponent("a-drawer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_form_item, { label: "标题" }, {
      default: _withCtx(() => [
        _createVNode(DynamicInput, {
          template: _unref(editor).meta.title_template,
          "onUpdate:template": _cache[0] || (_cache[0] = ($event: any) => ((_unref(editor).meta.title_template) = $event)),
          preview: _unref(editor).meta.preview.title,
          templates: _unref(material).titles.filter(_unref(editor).meta.tags),
          onPreview: _cache[1] || (_cache[1] = args => _unref(editor).meta.preview.title = args),
          onUpdate: _cache[2] || (_cache[2] = args => _unref(editor).meta.title_template = args)
        }, null, 8, ["template", "preview", "templates"])
      ]),
      _: 1
    }),
    _createVNode(_component_a_form_item, { label: "活动时间" }, {
      default: _withCtx(() => [
        _createVNode(_component_a_flex, {
          vertical: "",
          gap: "small"
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", null, [
              _createVNode(_component_a_range_picker, {
                value: info.date_range,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((info.date_range) = $event)),
                "disabled-date": disabledDate,
                onCalendarChange: onRangePickerChange,
                allowClear: false,
                "show-time": "",
                disabled: [_unref(editor).meta.publish_at,_unref(editor).meta.publish_at && _unref(dayjs)(_unref(editor).meta.end_at).isBefore(_unref(dayjs)())]
              }, null, 8, ["value", "disabled"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_form_item, { label: "弹幕" }, {
      default: _withCtx(() => [
        _createVNode(_component_a_switch, {
          checked: atmosphere.value.opt.is_barrage,
          "onUpdate:checked": _cache[4] || (_cache[4] = ($event: any) => ((atmosphere.value.opt.is_barrage) = $event)),
          "checked-children": "开",
          "un-checked-children": "关"
        }, null, 8, ["checked"])
      ]),
      _: 1
    }),
    _createVNode(_component_a_form_item, { label: "背景音乐" }, {
      default: _withCtx(() => [
        _createVNode(_component_a_button, {
          onClick: _cache[5] || (_cache[5] = () => info.music.show=true)
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(IconFont), {
              type: `icon${atmosphere.value.opt.music_url ? '' : '-no'}-music`
            }, null, 8, ["type"]),
            _createTextVNode(" " + _toDisplayString(atmosphere.value.musicName(atmosphere.value.opt.music_url)), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (_unref(theme).theme_id == null)
      ? (_openBlock(), _createBlock(_component_a_form_item, {
          key: 0,
          label: "背景图片"
        }, {
          default: _withCtx(() => [
            _createVNode(SingleUploadView, {
              image: _unref(theme).images[3][0].image_url,
              "onUpdate:image": _cache[6] || (_cache[6] = ($event: any) => ((_unref(theme).images[3][0].image_url) = $event)),
              showUploadButton: "",
              showUploadList: {showRemoveIcon: false, showDownloadIcon: false}
            }, null, 8, ["image"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_a_drawer, {
      open: info.music.show,
      "onUpdate:open": _cache[7] || (_cache[7] = ($event: any) => ((info.music.show) = $event)),
      title: "背景音乐",
      placement: "right"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_space, {
          direction: "vertical",
          class: "music-option"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_upload, {
              accept: ".mp3",
              data: (f) => _unref(session).ossSign(f,10 * 1024 * 1024),
              action: "https://activity-guandb-cn.oss-cn-shanghai.aliyuncs.com",
              "max-count": 1,
              onChange: onUploadChange
            }, {
              itemRender: _withCtx(({file}) => [
                (file.status == 'done')
                  ? (_openBlock(), _createBlock(AudioItem, {
                      key: 0,
                      name: "自定义音乐",
                      active: atmosphere.value.opt.music_url == file.url,
                      url: file.url,
                      "play-stat": atmosphere.value.active.audio.url == file.url && atmosphere.value.active.audio.playing,
                      onClick: ($event: any) => (setMusic(file.url))
                    }, null, 8, ["active", "url", "play-stat", "onClick"]))
                  : _createCommentVNode("", true)
              ]),
              default: _withCtx(() => [
                _createVNode(_component_a_button, { size: "large" }, {
                  default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                    _createTextVNode("上传", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data"]),
            (atmosphere.value.opt.music_url)
              ? (_openBlock(), _createBlock(_component_a_button, {
                  key: 0,
                  size: "large",
                  onClick: setNoMusic
                }, {
                  default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                    _createTextVNode("不用音乐", -1)
                  ]))]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_a_tabs, null, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(atmosphere.value.musicLibrary, (c) => {
              return (_openBlock(), _createBlock(_component_a_tab_pane, {
                key: c.name,
                tab: c.name
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_list, {
                    "data-source": c.data,
                    pagination: {defaultPageSize:10,hideOnSinglePage:true,showSizeChanger:false}
                  }, {
                    renderItem: _withCtx(({ item }) => [
                      _createVNode(AudioItem, {
                        active: atmosphere.value.opt.music_url == item.url,
                        url: item.url,
                        name: item.name,
                        "play-stat": atmosphere.value.active.audio.url == item.url && atmosphere.value.active.audio.playing,
                        onClick: ($event: any) => (setMusic(item.url))
                      }, null, 8, ["active", "url", "name", "play-stat", "onClick"])
                    ]),
                    _: 1
                  }, 8, ["data-source"])
                ]),
                _: 2
              }, 1032, ["tab"]))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["open"])
  ], 64))
}
}

})